<template>
    <div class="login">
      <div class="login__upper_spacer"></div>
        <div class="login__container">
            <div class="login__container__left">
                <OtCard :no-padding="true">
                    <router-view />
                </OtCard>
                <footer>
                    <div class="login__container__left__row">
                        <div
                            class="login__container__left__row__locale"
                            role="switch"
                            tabindex="0"
                            :aria-expanded="localeSwitchOpen"
                            :aria-checked="localeSwitchOpen"
                            @click="otLocaleSwitch.toggle()"
                            @keydown.space="otLocaleSwitch.toggle()"
                            @keydown.enter="otLocaleSwitch.toggle()"
                        >
                            <OtLocaleFlag :locale="$localization.locale" size="short" />

                            <i
                                class="oti is-small"
                                :class="localeSwitchOpen ? 'oti-drop-up' : 'oti-drop-down'"
                            />
                        </div>
                    </div>
                    <OtLocaleSwitch
                        class="login__container__left__locale-switch"
                        ref="ot-locale-switch"
                        @opened="onOpened"
                    />
                </footer>
            </div>
            <div class="login__container__right">
                <div  class="login__container__right__image">
                    <LoginHero />
                </div>
                <div class="login__container__right__row">
                    <a
                        class="login__container__right__row__logo"
                        :href="$whitelabel.website_url"
                        target="_blank"
                        aria-label="Go to website"
                    >
                        <Logo />
                    </a>
                    <div class="ot-text-tiny">
                        {{ $t('common.copyright', { year }) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import OtLocaleFlag from '../components/OtLocaleFlag.vue';
import OtLocaleSwitch from '../components/OtLocaleSwitch.vue';
import Logo from '../components/OtLogo.vue';
import LoginHero from '../components/LoginHero.vue';

@Component({
    components: {
        LoginHero,
        OtLocaleFlag,
        OtLocaleSwitch,
        Logo,
    },
})
export default class Layout extends Vue {

    @Ref('ot-locale-switch')
        otLocaleSwitch!: OtLocaleSwitch;

    year: number = new Date().getFullYear();

    localeSwitchOpen = false;

    onOpened(opened: boolean) {
        this.localeSwitchOpen = opened;
    }

}
</script>

<style lang="scss" scoped>
$card-width: 30rem;
$breakpoint: (2 * $card-width) + 5rem;

.login {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;

    &__upper_spacer {
      flex-basis: 10em;
      min-height: 1em;
      flex-shrink: 1;
    }

    --ot-card-border-radius: 0.5em;

    @media screen and (max-width: $breakpoint) {
      &__upper_spacer {
        flex-basis: 1em;
      }

        &__container {
            &__right {
                display: none !important;
            }

            &__right, &__left {
              max-width: $card-width;
              width: auto !important;
            }
        }
    }

    &__container {
        display: flex;
        gap: 5rem;

        &__right, &__left {
            width: $card-width;
        }

        &__right {
            display: flex;
            flex-direction: column;
            gap: var(--ot-spacing-3xl);

            &__row {
                display: flex;
                gap: var(--ot-spacing-lg);
                align-items: flex-start;
                color: var(--ot-color-core-accent-primary);

                &__logo {
                    color: inherit;
                    img {
                        height: 1.25rem;
                        filter: grayscale(1);
                        opacity: 0.75;
                    }
                }
            }
        }

        &__left {
            position: relative;
            display: flex;
            flex-direction: column;
            gap: var(--ot-spacing-2xl);
            padding-bottom: var(--ot-spacing-2xl);

            &__row {
                &__locale {
                    display: flex;
                }
            }

            .card {
                transition: all .5s ease-in-out;
                overflow: visible;
            }
        }

        footer {
            display: flex;
            margin: 0 var(--ot-spacing-sm);
            justify-content: flex-end;

            .locale-switch {
                position: absolute;
                left: 0;
                right: 0;
                margin-top: var(--ot-spacing-2xl);
            }
        }
    }
}

</style>
<style>
body {
  margin: 0;
  padding: 0;
}
</style>
